import { withInstall } from '../../../utils/with-install'
import LineLayer from './LineLayer.vue'

export const ElAmapLocaLine = withInstall(LineLayer)
export default ElAmapLocaLine
